import {gql} from 'apollo-angular';


export const donationAmountsGql = gql`
query ReloadDonationAmountsGql($fundraiserId: [Int!]) {
  Fundraiser(fundraiserId: $fundraiserId) {
    fundraiserDonationAmountRangeTypes {
      fundraiserPageDonationAmountRangeType {
        description
        fundraiserPageDonationAmountRangeTypeId
        name
      }
      amounts
    }
  }
}
`;